export const GET_SETTINGS = 'GET_SETTINGS';
export const GET_SETTINGS_START = `${GET_SETTINGS}_START`;
export const GET_SETTINGS_SUCCESS = `${GET_SETTINGS}_SUCCESS`;
export const GET_SETTINGS_FAIL = `${GET_SETTINGS}_FAIL`;

export const REMOVE_COMPANY_LOGO = `REMOVE_COMPANY_LOGO`;
export const REMOVE_COMPANY_LOGO_SUCCESS = `${REMOVE_COMPANY_LOGO}_SUCCESS`;
export const REMOVE_COMPANY_LOGO_FAIL = `${REMOVE_COMPANY_LOGO}_FAIL`;
export const UPDATE_GENERAL_SETTINGS = `UPDATE_GENERAL_SETTINGS`;
export const UPDATE_GENERAL_SETTINGS_SUCCESS = `${UPDATE_GENERAL_SETTINGS}_SUCCESS`;
export const UPDATE_GENERAL_SETTINGS_FAIL = `${UPDATE_GENERAL_SETTINGS}_FAIL`;
export const UPDATE_COMPANY_LOGO = `UPDATE_COMPANY_LOGO`;
export const UPDATE_COMPANY_LOGO_SUCCESS = `${UPDATE_COMPANY_LOGO}_SUCCESS`;
export const UPDATE_COMPANY_LOGO_FAIL = `${UPDATE_COMPANY_LOGO}_FAIL`;
export const UPLOAD_COMPANY_LOGO = `UPLOAD_COMPANY_LOGO`;
export const UPLOAD_COMPANY_LOGO_SUCCESS = `${UPLOAD_COMPANY_LOGO}_SUCCESS`;
export const UPLOAD_COMPANY_LOGO_FAIL = `${UPLOAD_COMPANY_LOGO}_FAIL`;
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const UPDATE_SETTINGS_SUCCESS = `${UPDATE_SETTINGS}_SUCCESS`;
export const UPDATE_SETTINGS_FAIL = `${UPDATE_SETTINGS}_FAIL`;

export const VERIFY_CALLERID = 'VERIFY_CALLERID';
export const VERIFY_CALLERID_SUCCESS = `${VERIFY_CALLERID}_SUCCESS`;
export const VERIFY_CALLERID_FAIL = `${VERIFY_CALLERID}_FAIL`;

export const GET_CALLERID_STATUS = 'GET_CALLERID_STATUS';
export const GET_CALLERID_STATUS_SUCCESS = `${GET_CALLERID_STATUS}_SUCCESS`;
export const GET_CALLERID_STATUS_FAIL = `${GET_CALLERID_STATUS}_FAIL`;

export const CLEAR_CALLERID_STATUS = 'CLEAR_CALLERID_STATUS';

const uri = '/webapi/xm/1/settings';

export function getSettings(embeds) {
  return {
    type: GET_SETTINGS,
    meta: {
      xmApi: true,
      uri: `${uri}${embeds ? `?embed=${embeds}` : ''}`,
      method: 'get',
    },
    broadcast: true,
  };
}

export function verifyCallerId(number) {
  return {
    type: VERIFY_CALLERID,
    meta: {
      xmApi: true,
      uri: `${uri}/callerid-overrides`,
      method: 'post',
      params: {
        number,
      },
    },
  };
}

export function getCallerIdStatus(id) {
  return {
    type: GET_CALLERID_STATUS,
    meta: {
      xmApi: true,
      uri: `${uri}/callerid-overrides/${id}`,
      method: 'get',
    },
  };
}

export function clearCallerIdStatus() {
  return {
    type: CLEAR_CALLERID_STATUS,
  };
}

export function uploadCompanyLogo(file) {
  return {
    type: UPLOAD_COMPANY_LOGO,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/settings/logo`,
      method: 'post',
      contentType: 'multipart/form-data',
      params: {
        hasFile: true,
        file,
      },
    },
  };
}
export function updateCompanyLogo(logo) {
  return {
    type: UPDATE_COMPANY_LOGO,
    payload: logo,
  };
}

export function removeCompanyLogo() {
  return {
    type: REMOVE_COMPANY_LOGO,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/settings/logo`,
      method: 'del',
    },
  };
}

export function updateSettings(settings) {
  return {
    type: UPDATE_SETTINGS,
    meta: {
      xmApi: true,
      uri,
      method: 'post',
      params: settings,
    },
    broadcast: true,
  };
}

export function updateSettingsSuccess(payload) {
  return {
    type: UPDATE_SETTINGS_SUCCESS,
    payload,
  };
}
